export class pageRouteUrls
{
    public static Home(): string  {
        return  `/home`;
    }
    public static Login(): string  {
        return  `/login`;
    }
    public static Register(): string  {
        return  `/register`;
    }
    /** Public pricing page — intentionally NOT linked in the nav bar. */
    public static Pricing(): string  {
        return  `/pricing`;
    }
    /** SEO comparison page, e.g. /vs/teachable. Slug: teachable | thinkific | kajabi. */
    public static VsCompetitor(competitor: string): string  {
        return  `/vs/${competitor}`;
    }
    /** SEO category landing page for "cheapest platform to teach live online". */
    public static CheapestLiveTeaching(): string  {
        return  `/cheapest-platform-to-teach-live-online`;
    }

    public static LectureView(token:string|undefined): string  {
        return  `/course/lecture/view/${token}`;
    }
    public static LectureEdit(courseToken:string|undefined,token:string): string  {
        return  `/course/${courseToken}/lecture/edit/${token}`;
    }
    public static LectureLiveSession(token:string): string  {
        return  `/course/lecture/live/${token}`;
    }
    public static LectureAdd(courseToken:string|undefined): string  {
        return  `/course/${courseToken}/lecture/add`;
    }
    public static LectureInvoices(token:string|undefined): string  {
        return  `/course/lecture/invoices/${token}`;
    }
    // public static AccessManager(): string  {
    //     return  `/course/lecture/accessManager`;
    // }
    // public static CourseAccessManager(courseToken:string): string  {
    //     return  `/course/lecture/accessManager/course/${courseToken}`;
    // }
    // public static LectureAccessManager(lectureToken:string): string  {
    //     return  `/course/lecture/accessManager/lecture/${lectureToken}`;
    // }
    
    public static Dashboard():string{
        return  `/dashboard`;
    }
      
    public static CourseAdd(): string  {
        return  `/course/Add`;
    }
    public static CourseEdit(token:string): string  {
        return  `/course/edit/${token}`;
    }
    public static CourseView(token:string): string  {
        return  `/course/view/${token}`;
    }
    public static CourseOverview(token:string): string  {
        return  `/course/overview/${token}`;
    }
    public static CourseContent(token:string): string  {
        return  `/course/content/${token}`;
    }
    public static Search(): string  {
        return  `/search/`;
    }
    public static SearchByCategory(categoryToken: string, categoryName?: string): string {
        const params = new URLSearchParams();
        params.set("categoryToken", categoryToken);
        if (categoryName) params.set("query", categoryName);
        return `/search/?${params.toString()}`;
    }
    public static CourseMy(): string  {
        return  `/courses/my`;
    }
    public static QuestionBank(): string  {
        return  `/courses/question-bank`;
    }
    
    public static Messages(): string  {
        return  `/Messages`;
    }
    /** Open the inbox focused on a specific conversation. */
    public static MessagesTo(userToken: string): string {
        return `/Messages?to=${userToken}`;
    }
    public static Billing(): string  {
        return  `/billing`;
    }
    public static Checkout(): string  {
        return  `/checkout/checkout`;
    }
    
    public static ProcessPayment(): string  {
        return  `/checkout/processPayment`;
    }
    public static PaymentCancele(): string  {
        return  `/checkout/PaymentCanceled`;
    }
    /** Public, no-login invoice payment link — sent in the "New Invoice" email. */
    public static PublicInvoicePay(invoiceToken: string): string  {
        return  `/pay-invoice/${invoiceToken}`;
    }
    public static PublicCertificateView(certificateToken: string): string  {
        return  `/certificate/${certificateToken}`;
    }
    public static SubscriptionManagement(): string  {
        return  `/subscriptionManagement`;
    }
    
    public static Payments(): string  {
        return  `/AdminPanel/Payments`;
    }
    public static AdminUsersList(): string  {
        return  `/AdminPanel/Users`;
    }
    public static AdminPromoCodes(): string  {
        return  `/AdminPanel/PromoCodes`;
    }
    public static AdminFeedback(): string  {
        return  `/AdminPanel/Feedback`;
    }
    public static AdminMarketingEmails(): string  {
        return  `/AdminPanel/MarketingEmails`;
    }
    public static AdminMarketingWhatsApp(): string  {
        return  `/AdminPanel/MarketingWhatsApp`;
    }
    public static AdminCalls(): string  {
        return  `/AdminPanel/Calls`;
    }

    public static InstructorView(token?:string|undefined): string  {
        if(token)
            return  `/instructor/view/${token}`;
        else
            return "#";
    }
    public static InstructorEdit(): string  {
        return  `/instructor/edit`;
    }
    public static InstructorVerification(): string  {
        return  `/instructor/verification`;
    }
    public static InstructorVerificationList(): string  {
        return  `/instructor/verificatorList`;
    }

    public static FavoriteLists(): string  {
        return  `/favorites`;
    }
    public static InstructorFollowList(): string  {
        return  `/instructor/follow`;
    } 
 
    public static MyChildrenPage(): string  {
        return  `/parent/myChildren`;
    }
    public static ParentReports(): string  {
        return  `/parent/reports`;
    }
    public static MyCertificates(): string  {
        return  `/my-certificates`;
    }
    public static ChildrenCertificates(): string  {
        return  `/parent/certificates`;
    }
    
    public static UserEdit(): string  {
        return  `/user/edit`;
    }
    public static VerifyEmail(): string  {
        return  `/verify-email`;
    }
    public static ForgotPassword(): string  {
        return  `/forgot-password`;
    }
    public static ResetPassword(): string  {
        return  `/reset-password`;
    }
    public static StudentEdit(): string  {
        return  `/student/edit`;
    }

    public static StudentView(token?: string): string {
        return token ? `/student/view/${token}` : "#";
    }
    public static ParentEdit(): string  {
        return  `/parent/edit`;
    }
    public static UserSettings(): string  {
        return  `/settings/notifications`;
    }
    public static MyStudents(): string {
        return `/students/my`;
    }

    public static MyHomework(): string {
        return `/homework/my`;
    }

    public static MyExams(): string {
        return `/exams/my`;
    }

    public static StudentInvoices(): string {
        return `/students/invoices`;
    }

    public static AcademyTutors(): string {
        return `/academy/tutors`;
    }

    public static AcademyReports(): string {
        return `/academy/reports`;
    }

    public static AcademyView(token?: string): string {
        return token ? `/academy/view/${token}` : "#";
    }
    
    public static Error(errorCode:string="500"): string  {
        return  `/error/${errorCode}`;
    }
    public static ErrorNotAuth(): string  {
        return  `/errorNotAuth`;
    }
    public static HelpCenter(): string  {
        return  `/help`;
    }
    public static HelpArticle(slug: string): string  {
        return  `/help/${slug}`;
    }
    public static PrivacyPolicy(): string  {
        return  `/privacy-policy`;
    }
    public static TermsAndConditions(): string  {
        return  `/terms-and-conditions`;
    }
    public static ContactUs(): string  {
        return  `/contact-us`;
    }

}